import request from '@/utils/request'

let Product_cpApi = {

  /*产品与库存列表*/
  list(data) {
    return request._post('/shop/plus.product_cp.Index/index', data);
},
getCategory(data){
     return request._post('/shop/plus.product_cp.Index/getCategory', data);
},
/*添加产品与库存*/
add(data) {
    return request._post('/shop/plus.product_cp.Index/add', data);
},
/*修改产品与库存*/
edit(data) {
    return request._post('/shop/plus.product_cp.Index/edit', data);
},
/*删除产品与库存*/
del(data) {
    return request._post('/shop/plus.product_cp.Index/del', data);
},
/*产品与库存详情*/
detail(data) {
  return request._post('/shop/plus.product_cp.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.product_cp.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.product_cp.Setting/getSetting', data, errorback);
    },
}
export default Product_cpApi;



// WEBPACK FOOTER //
// ./src/api/product_cp.js